import { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

// form
import { useForm } from 'react-hook-form';
import { LoadingButton } from '@mui/lab';

// @mui
import { FormHelperText, Stack, Typography, TextField, IconButton, InputAdornment } from '@mui/material';
import Iconify from '../../components/iconify';
// components

import FormProvider from '../../components/hook-form';
import LoadingProgressBar from '../../components/loading-progressbar/loadingprogressbar';
import { PATH_MASTERS } from '../../routes/paths';
import UserLoginService from '../../services/userlogin.service';
import AppCache from '../../services/appcache';


// ----------------------------------------------------------------------

export default function AuthLoginForm() {
    const navigate = useNavigate();
    const { email: paramEmail, id } = useParams(); // Dynamic params from URL
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false);
    const [validationMessage, setValidationMessage] = useState('');
    const [showPassword, setShowPassword] = useState(false);



    const defaultValues = {
        email: paramEmail || '', // Use dynamic email if present, otherwise empty
        password: '',
    };

    const methods = useForm({

        defaultValues,
    });

    const { handleSubmit, register, watch } = methods;
    const values = watch();



    const onSubmit = async (data) => {
        setErrorMessage(true)
        if (!data.email || !data.password) {
            return
        }
        setLoading(true);
        try { // NOSONAR
            const payload = { LoginEmailId: data.email, Password: data.password };
            UserLoginService.then((userServiceInstance) => {
                userServiceInstance.UserLogin(payload)
                    .then((response) => {
                        if (response.status === 200) {
                            AppCache.SetCurrentLoggedInUser(response.data);
                            AppCache.GetCurrentLoggedInUser();
                            const isClaimUrl = window.location.href.includes('ContractClaimApproval'); // Check if 'claim' is in the URL
                            const isGmailAndId = paramEmail && id;

                            if (isClaimUrl && isGmailAndId) {
                                // ClaimApproval Claim Login
                                sessionStorage.setItem('email', paramEmail);
                                sessionStorage.setItem('id', id);
                                sessionStorage.setItem('hideShow', true);
                                setLoading(false);
                                navigate(`/Claim/ContractClaimApproval/ContractConsolidate/${id}`);
                            }
                            else if (isGmailAndId) {
                                // Distributor Claim Login
                                sessionStorage.setItem('email', paramEmail);
                                sessionStorage.setItem('id', id);
                                setLoading(false);
                                navigate(PATH_MASTERS.DistributorClaimApproval);
                            } else {
                                setLoading(false);
                                // Regular Login
                                navigate(PATH_MASTERS.root);
                            }
                            setErrorMessage(false)
                        } else {
                            setValidationMessage('Invalid username or password.');
                            setLoading(false);
                        }
                    }).catch((err) => {
                         //  console.log(err);
                        setValidationMessage('Something went wrong. Please try again.');
                        setLoading(false);
                    });

            });
        } catch (error) {
            setValidationMessage('An error occurred. Please try again.');
            setTimeout(() => {
                setLoading(false);
            }, 500); // Delay of 1.5 seconds
        }
    };
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // NOSONAR

    return (
        <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
            <Stack spacing={4}>
                <img src="/logo/ProClaimz Logo.jpg" alt=" " style={{ height: 70, objectFit: 'contain' }} />
                <div>
                    <TextField
                        {...register('email')}
                        label="User Name"
                        size="small"
                        InputProps={{
                            readOnly: Boolean(paramEmail), // Read-only if dynamic email is present
                        }}
                        fullWidth
                        sx={{
                            transition: 'opacity 0.5s ease', // Smooth fade effect
                            opacity: paramEmail ? 0.5 : 1, // Fade effect when pre-filled
                            pointerEvents: paramEmail ? 'none' : 'auto', // Disable interaction if pre-filled
                            '& .MuiInputBase-input': {
                                fontSize: '13px',  // Set text size to 13px
                            },
                            '& .MuiFormLabel-root': {
                                fontSize: '14px',  // Set label text size to 14px
                            },
                        }}
                    />

                    {errorMessage && (!values.email || !emailRegex.test(values.email)) && (
                        <FormHelperText style={{ color: 'red', fontSize: '12px' }} >
                            {!values.email ? "Email is required" : ""} {/* This message is now removed -  Email must be a valid email address */}
                        </FormHelperText>
                    )}
                </div>
                <div>
                    <TextField
                        {...register('password')}
                        label="Password"
                        size="small"
                        type={showPassword ? 'text' : 'password'}
                        fullWidth
                        sx={{
                            transition: 'opacity 0.5s ease', // Smooth fade effect
                            opacity: paramEmail ? 0.5 : 1, // Fade effect when pre-filled
                            pointerEvents: paramEmail ? 'none' : 'auto', // Disable interaction if pre-filled
                            '& .MuiInputBase-input': {
                                fontSize: '13px',  // Set text size to 13px
                            },
                            '& .MuiFormLabel-root': {
                                fontSize: '14px',  // Set label text size to 14px
                            },
                        }}

                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                                        <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                                    </IconButton>
                                </InputAdornment>
                            ),
                        }}

                    />
                    {errorMessage && !values.password && (
                        <FormHelperText style={{ color: 'red', fontSize: '12px' }} >
                            Password is required
                        </FormHelperText>
                    )}
                </div>
                {validationMessage && (
                    <Typography color="red" variant="body2" sx={{ textAlign: 'center' }}>
                        {validationMessage}
                    </Typography>
                )}
            </Stack>

            <Stack alignItems="flex-end" sx={{ my: 2 }} />

            <LoadingButton
                fullWidth
                color="inherit"
                size="large"
                type="submit"
                variant="contained"
                sx={{
                    bgcolor: '#CCF4FE',
                    fontSize: '16px',
                    '&:hover': {
                        bgcolor: '#99E3FF',
                    },
                }}
            >
                Login
            </LoadingButton>
            {loading && <LoadingProgressBar />}
        </FormProvider>
    );
}
